import {createAsyncThunk} from '@reduxjs/toolkit';
import {TranscriptionJob} from '../../domain/types';

/**
 * Transcription queue — NOT YET IMPLEMENTED ON THE WEB.
 *
 * On the desktop app every thunk here drove a Rust-side queue that shelled out to a local
 * Python/WhisperX install (`get_transcription_queue`, `start_queue_processing`, …). None of that
 * exists in the browser.
 *
 * Transcription is moving to a server-side job queue backed by AssemblyAI. Until those endpoints
 * exist these thunks reject with a clear message instead of silently doing nothing, so the queue
 * UI renders and reports honestly rather than appearing to work.
 *
 * See docs/BACKEND_REQUESTS.md — "Server-side transcription jobs".
 */

const NOT_IMPLEMENTED =
  'Transcription queue is not available yet — it is moving to a server-side job queue.';

export const fetchQueue = createAsyncThunk<TranscriptionJob[], void, { rejectValue: string }>(
  'queue/fetchQueue',
  async () => {
    // Resolves empty rather than rejecting: the queue page polls this, and a rejection loop
    // would spam the user with error toasts on a page that is simply not wired up yet.
    return [];
  }
);

export const startQueueProcessing = createAsyncThunk<void, string | undefined, { rejectValue: string }>(
  'queue/startQueueProcessing',
  async (_, {rejectWithValue}) => rejectWithValue(NOT_IMPLEMENTED)
);

export const stopQueueProcessing = createAsyncThunk<void, void, { rejectValue: string }>(
  'queue/stopQueueProcessing',
  async (_, {rejectWithValue}) => rejectWithValue(NOT_IMPLEMENTED)
);

export const addToQueue = createAsyncThunk<
  void,
  { audioPath: string; csvFileName: string; projectId: string | null },
  { rejectValue: string }
>(
  'queue/addToQueue',
  async (_, {rejectWithValue}) => rejectWithValue(NOT_IMPLEMENTED)
);

export const removeFromQueue = createAsyncThunk<void, string, { rejectValue: string }>(
  'queue/removeFromQueue',
  async (_, {rejectWithValue}) => rejectWithValue(NOT_IMPLEMENTED)
);
